export default __webpack_public_path__ + "static/media/shield-checkmark.c0dbb9e8.svg";